export { default } from './InsuredPieChart';
